<div class="grid p-align-center grid-nogutter">
  <div class="lg:col-8 xl:col-9 sm:col-0 md:col-0 pb-0 grid-nogutter security-left-column hidden lg:inline-flex"></div>
  <div class="col ml-6 mr-6 pb-2 security-right-column frm-filters-ui-v2">
    <div class="align-items-center text-center mt-6 mb-3">
      <img
        alt="Логотип ФРМ"
        src="assets/images/frm-logo-v2.png"
        style="height: 170px" />
    </div>

    <router-outlet></router-outlet>

    <div class="flex p-justify-end mt-6 copyright">
      <small>ФРМ-Менеджмент</small>
    </div>
    <div class="flex p-justify-end mt-1 copyright">
      <small>Все права защищены. ⓒ {{ footerYear }}</small>
    </div>
  </div>
</div>
